export const DATA_HOOKS = {
  ICON_WRAPPER: 'vertical-tabs-icon-item-wrapper',
} as const;
